<template>
  <div>
    <van-form @submit="onSubmit">
       <van-field
        v-model="user.id"
        required
        name="id"
        v-show="false"

       
      />
      <van-field
        v-model="user.nickname"
        required
        name="nickname"
        label="姓名"
        placeholder="姓名"
        :rules="[{ required: true, message: '请填写姓名' }]"
      />
      <van-field
        v-model="user.telphone"
        required
        type="tel"
        name="telphone"
        label="手机号"
        placeholder="手机号"
        :rules="[{ required: true, message: '请填写手机号' },{ pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误！'}]"
      />
      <van-field
        v-model="user.address"
        required
        type="tel"
        name="address"
        label="详细地址"
        placeholder="详细地址"
        :rules="[{ required: true, message: '请填写详细地址' }]"
      />
      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit"
          >提交</van-button
        >
      </div>
    </van-form>
  </div>
</template>
<script>
import { Dialog,Notify,Toast } from 'vant'

import URL from "@/api/api";
export default {

  
  data() {
    return {
      id:"",
      openid:"",
      user:{
        id:'',
        nickname: "",
      telphone: "",
      address: "",
      }
      
    };
  },
  created(){
    this.fatchdata();
  },
  methods: {
    fatchdata(){
      this.openid=localStorage.getItem("openid");
      this.id=this.$route.query.batchid
      this.$fetchGet(URL.getuserdetail.url,{batchId:this.id,openid:this.openid}).then(res=>{
        this.user=res.data.data
      })
    },
      onSubmit(values) {
      this.$fetchPost(URL.updateuserdetail.url,values).then(res=>{
        Toast("保存成功")
      })
       Toast('保存失败');
      
    },
  },
};
</script>